import * as React from 'react';
import * as styles from './Permissions.css';
import { LocalizationService } from '../../services/LocalizationService';
import { GroupList, GroupListColumnType } from '../../interfaces/IGroupList'
import { IAGroupList } from '../groupList/GroupList';
import PermissionsService, { IGetPermissionsForInstanceResponse } from '../../services/PermissionsService';
import { IInstance } from '../../interfaces/IInstance';
import InstanceService from '../../services/InstanceService';
import { inject, observer } from 'mobx-react';
import { PermissionsStore } from './stores';
import { PermissionsPanel } from './permissionsPanel/PermissionsPanel';
import { ConditionalOutputFactory } from '../../services/ConditionalOutputFactory';
import { UniquePermissionsResult } from '../../interfaces/UniquePermissionsResult';
import { Helper } from '../../Helper';

export interface IPermissionsProps {
  permissionsStore?: PermissionsStore;
}

@inject('permissionsStore')
@observer
export class Permissions extends React.Component<IPermissionsProps> {

  private localizationService: LocalizationService = new LocalizationService();

  public componentDidMount(): void {
    this.getApplicationPermissions();
    this.getApplicationInstances();
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private getApplicationPermissions(): void {
    // Admin
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "Admin").then((isPermissionSet: boolean) => {
      this.props.permissionsStore.adminHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.adminHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.adminHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Mobile app
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "AppAdmin").then((isPermissionSet: boolean) => {
      this.props.permissionsStore.mobileAppHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.mobileAppHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.mobileAppHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Events
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.EVENTS).then((isPermissionSet: boolean) => {
      this.props.permissionsStore.eventsHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.eventsHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.eventsHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Navigator
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.NAVIGATOR).then((isPermissionSet: boolean) => {
      this.props.permissionsStore.navigatorHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.navigatorHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.navigatorHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Toolbox
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.TOOLBOX).then((isPermissionSet: boolean) => {
      this.props.permissionsStore.toolboxHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.toolboxHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.toolboxHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Messages
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.MESSAGES).then((isPermissionSet: boolean) => {
      this.props.permissionsStore.messagesHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.messagesHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.messagesHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Content creator
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.CONTENT_CREATOR).then((isPermissionSet: boolean) => {
      this.props.permissionsStore.contentCreatorHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.contentCreatorHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.contentCreatorHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });

    // Content organizer
    PermissionsService.getPermissionsForApplication(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.CONTENT_ORGANIZER).then((isPermissionSet: boolean) => {
      this.props.permissionsStore.contentOrganizerHasPermissions = isPermissionSet ? UniquePermissionsResult.Yes : UniquePermissionsResult.No;
      this.forceUpdate();
    })
    .catch((response: Response) => {
      if (response.status == 403) {
        this.props.permissionsStore.contentOrganizerHasPermissions = UniquePermissionsResult.NoAccess;
      } else {
        this.props.permissionsStore.contentOrganizerHasPermissions = UniquePermissionsResult.Error;
      }
      this.forceUpdate();
    });
  }

  private getApplicationInstances(): void {
    // Mobile app
    InstanceService.getInstances(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "IntraActive-AppAdmin", true).then((mobileAppInstances: IInstance[]) => {
      this.props.permissionsStore.mobileAppInstances = Helper.sortAlphabeticalByTitle(mobileAppInstances);
      this.forceUpdate();
    });

    // Events
    InstanceService.getInstances(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "IntraActive-Events", true).then((eventInstances: IInstance[]) => {
      this.props.permissionsStore.eventInstances = Helper.sortAlphabeticalByTitle(eventInstances);
      this.forceUpdate();
    });

    // Navigator
    InstanceService.getInstances(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "IntraActive-NavigatorAdmin", true).then((navigatorInstances: IInstance[]) => {
      this.props.permissionsStore.navigatorInstances = Helper.sortAlphabeticalByTitle(navigatorInstances);
      this.forceUpdate();
    });

    // Messages
    InstanceService.getInstances(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "IntraActive-Messages", true).then((messagesInstances: IInstance[]) => {
      this.props.permissionsStore.messagesInstances = Helper.sortAlphabeticalByTitle(messagesInstances);
      this.forceUpdate();
    });

    // Content creator
    InstanceService.getInstances(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, "IntraActive-ContentCreator", true).then((contentCreatorInstances: IInstance[]) => {
      this.props.permissionsStore.contentCreatorInstances = Helper.sortAlphabeticalByTitle(contentCreatorInstances);
      this.forceUpdate();
    });

    InstanceService.getInstances(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, `IntraActive-${this.props.permissionsStore.CONTENT_ORGANIZER}`, true).then((contentOrganizerInstances: IInstance[]) => {
      this.props.permissionsStore.contentOrganizerInstances = Helper.sortAlphabeticalByTitle(contentOrganizerInstances);
      this.forceUpdate();
    });
  }

  private getInstancesPermission(application: string, instances: IInstance[]): void {
    if (instances.length > 0 && instances[0].hasUniquePermissions === undefined) {
      instances.forEach((instance: IInstance) => {
        PermissionsService.getPermissionsForInstance(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, application, instance.instanceName ? instance.instanceName : "Default")
        .then((getPermissionsForInstanceResponse: IGetPermissionsForInstanceResponse) => {
          if (getPermissionsForInstanceResponse !== undefined) {
            instance.hasUniquePermissions = getPermissionsForInstanceResponse.hasUniquePermissions
              ? UniquePermissionsResult.Yes
              : UniquePermissionsResult.No;

            instance.hasSpecialPermissions = getPermissionsForInstanceResponse.hasSpecialPermissions;
          }
          this.forceUpdate();
        })
        .catch((response: Response) => {
          if (response.status == 403) {
            instance.hasUniquePermissions = UniquePermissionsResult.NoAccess;
          } else {
            instance.hasUniquePermissions = UniquePermissionsResult.Error;
          }
          this.forceUpdate();
        });
      });
    }
  }

  private getApplication(application: string, hasUniquePermissions: UniquePermissionsResult, index, instances?: IInstance[]): any {
    return (
      {
        name: application,
        expanded: false,
        title: application,
        clickableGroupTitle: true,
        toolTip: ConditionalOutputFactory
          .WithDefault(null)
          .OnCondition(application == this.props.permissionsStore.ADMIN, this.localizationService.strings.Permissions_AdminTooltip)
          .Last(),
        groupValues: {
          title: application,
          id: index,
          name: application,
          columns: [
            {
              type: GroupListColumnType.Text,
              value: ConditionalOutputFactory
                  .WithDefault(this.localizationService.strings.Permissions_Loading)
                  .OnCondition(hasUniquePermissions == UniquePermissionsResult.Yes, this.localizationService.strings.Permissions_Set)
                  .OnCondition(hasUniquePermissions == UniquePermissionsResult.No, this.localizationService.strings.Permissions_NotSet)
                  .OnCondition(hasUniquePermissions == UniquePermissionsResult.NoAccess, this.localizationService.strings.Permissions_NoAccess)
                  .OnCondition(hasUniquePermissions == UniquePermissionsResult.Error, this.localizationService.strings.Permissions_ErrorWhileRequesting)
                  .Last()
            },
            ConditionalOutputFactory
              .WithDefault({
                type: GroupListColumnType.Icon,
                value: false as any,
              })
              .OnCondition(
                hasUniquePermissions == UniquePermissionsResult.NoAccess
                  || hasUniquePermissions == UniquePermissionsResult.Error, {
                type: GroupListColumnType.Text,
                value: "",
              })
              .Last(),
          ]
        },
        items: instances !== undefined ? this.getInstanceRows(application, instances) : []
      }
    );
  }

  private getInstanceRows(application: string, instances: IInstance[]): any[] {
    const instanceRows = [];
    if (instances.length > 0) {
      instances.forEach((instance: IInstance) => {
        instanceRows.push(
          {
            title: instance.title,
            id: instance?.id,
            name: instance.instanceName,
            columns: this.getColumnsForInstance(application, instance)
          }
        );
      });
    }
    return instanceRows;
  }

  private getColumnsForInstance(application: string, instance: IInstance): any[] {
    return (
      [
        {
          type: GroupListColumnType.Text,
          value: ConditionalOutputFactory
            .WithDefault(this.localizationService.strings.Permissions_Loading)
            .OnCondition(instance.hasUniquePermissions == UniquePermissionsResult.Yes, this.localizationService.strings.Permissions_UniquePermissions)
            .OnCondition(instance.hasUniquePermissions == UniquePermissionsResult.No, this.localizationService.strings.Permissions_InheritPermissions + application)
            .OnCondition(instance.hasSpecialPermissions, this.localizationService.strings.Permissions_SpecialPermissions)
            .OnCondition(instance.hasUniquePermissions == UniquePermissionsResult.No && application === this.localizationService.strings.Admin_ContentOrganizer, this.localizationService.strings.Permissions_SpecialPermissions)
            .OnCondition(instance.hasUniquePermissions == UniquePermissionsResult.NoAccess, this.localizationService.strings.Permissions_NoAccess)
            .OnCondition(instance.hasUniquePermissions == UniquePermissionsResult.Error, this.localizationService.strings.Permissions_ErrorWhileRequesting)
            .Last()
        },
        ConditionalOutputFactory
          .WithDefault({
            type: GroupListColumnType.Icon,
            value: false as any,
          })
          .OnCondition(
            instance.hasUniquePermissions == UniquePermissionsResult.NoAccess
              || instance.hasUniquePermissions == UniquePermissionsResult.Error, {
            type: GroupListColumnType.Text,
            value: "",
          })
          .Last()
      ]
    )
  }

  public render(): JSX.Element {
    const groups: GroupList = {
      columns: [{ title: this.localizationService.strings.Permissions, name: "permissions", width: "275px" }, { title: "", name: "edit", width: "50px" }],
      groups: [
        this.getApplication(this.localizationService.strings.Admin_Admin, this.props.permissionsStore.adminHasPermissions, 1),
        this.getApplication(this.localizationService.strings.Admin_MobileApp, this.props.permissionsStore.mobileAppHasPermissions, 2, this.props.permissionsStore.mobileAppInstances),
        this.getApplication(this.localizationService.strings.Admin_Events, this.props.permissionsStore.eventsHasPermissions, 3, this.props.permissionsStore.eventInstances),
        this.getApplication(this.localizationService.strings.Admin_Navigator, this.props.permissionsStore.navigatorHasPermissions, 4, this.props.permissionsStore.navigatorInstances),
        this.getApplication(this.localizationService.strings.Admin_Toolbox, this.props.permissionsStore.toolboxHasPermissions, 6),
        this.getApplication(this.localizationService.strings.Admin_Messages, this.props.permissionsStore.messagesHasPermissions, 7, this.props.permissionsStore.messagesInstances),
        this.getApplication(this.localizationService.strings.Admin_ContentCreator, this.props.permissionsStore.contentCreatorHasPermissions, 8, this.props.permissionsStore.contentCreatorInstances),
      ],
      nameFirstColumn: this.localizationService.strings.Permissions_ApplicationsAndInstances
    }

    groups.groups.push(this.getApplication(this.localizationService.strings.Admin_ContentOrganizer, this.props.permissionsStore.contentOrganizerHasPermissions, 9, this.props.permissionsStore.contentOrganizerInstances));
    
    return (
      <div>
        <PermissionsPanel
          update={() => this.forceUpdate()}
        />
        <div className={styles.infoText}>{this.localizationService.strings.Permissions_Description}</div>
        <IAGroupList
          highlightColor={this.props.permissionsStore.highlightColor}
          groupsItem={groups}
          getUpdates={(items, item, application) => {
            console.log(items);
            if (application !== undefined) {
              switch (application) {
                case this.localizationService.strings.Admin_Messages:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.MESSAGES;
                  if (this.props.permissionsStore.messagesInstances.length > 0) {
                    this.props.permissionsStore.messagesInstances.forEach((messagesInstance: IInstance) => {
                      if (messagesInstance.id === item.id) {
                        this.props.permissionsStore.selectedInstance = messagesInstance;
                      }
                    });
                  }
                  break;
                case this.localizationService.strings.Admin_MobileApp:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.MOBILE_APP;
                  if (this.props.permissionsStore.mobileAppInstances.length > 0) {
                    this.props.permissionsStore.mobileAppInstances.forEach((instance: IInstance) => {
                      if (instance?.id === item.id) {
                        this.props.permissionsStore.selectedInstance = instance;
                      }
                    });
                  }
                  break;
                case this.localizationService.strings.Admin_Events:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.EVENTS;
                  if (this.props.permissionsStore.eventInstances.length > 0) {
                    this.props.permissionsStore.eventInstances.forEach((instance: IInstance) => {
                      if (instance?.id === item.id) {
                        this.props.permissionsStore.selectedInstance = instance;
                      }
                    });
                  }
                  break;
                case this.localizationService.strings.Admin_Navigator:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.NAVIGATOR;
                  if (this.props.permissionsStore.navigatorInstances.length > 0) {
                    this.props.permissionsStore.navigatorInstances.forEach((instance: IInstance) => {
                      if (instance?.id === item.id) {
                        this.props.permissionsStore.selectedInstance = instance;
                      }
                    });
                  }
                  break;
                case this.localizationService.strings.Admin_ContentCreator:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.CONTENT_CREATOR;
                  if (this.props.permissionsStore.contentCreatorInstances.length > 0) {
                    this.props.permissionsStore.contentCreatorInstances.forEach((instance: IInstance) => {
                      if (instance?.id === item.id) {
                        this.props.permissionsStore.selectedInstance = instance;
                      }
                    });
                  }
                  break;
                  case this.localizationService.strings.Admin_ContentOrganizer:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.CONTENT_ORGANIZER;
                  if (this.props.permissionsStore.contentOrganizerInstances.length > 0) {
                    this.props.permissionsStore.contentOrganizerInstances.forEach((instance: IInstance) => {
                      if (instance?.id === item.id) {
                        this.props.permissionsStore.selectedInstance = instance;
                      }
                    });
                  }
                  break;
                default:
                  break;
              }
            } else {
              switch (item.title) {
                case this.localizationService.strings.Admin_Admin:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.ADMIN;
                  break;
                case this.localizationService.strings.Admin_Toolbox:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.TOOLBOX;
                  break;
                case this.localizationService.strings.Admin_Messages:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.MESSAGES;
                  break;
                case this.localizationService.strings.Admin_MobileApp:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.MOBILE_APP;
                  break;
                case this.localizationService.strings.Admin_Events:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.EVENTS;
                  break;
                case this.localizationService.strings.Admin_Events:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.EVENTS;
                  break;
                case this.localizationService.strings.Admin_Navigator:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.NAVIGATOR;
                  break;
                case this.localizationService.strings.Admin_ContentCreator:
                  this.props.permissionsStore.selectedApplication = this.props.permissionsStore.CONTENT_CREATOR;
                  break;
                  case this.localizationService.strings.Admin_ContentOrganizer:
                    this.props.permissionsStore.selectedApplication = this.props.permissionsStore.CONTENT_ORGANIZER;
                    break;
                default:
                  break;
              }
            }
          }}
          onExpand={(group: string, expanded: boolean) => {
            switch (group) {
              case this.localizationService.strings.Admin_Messages:
                if (expanded) {
                  this.getInstancesPermission(this.props.permissionsStore.MESSAGES, this.props.permissionsStore.messagesInstances);
                }
                break;
              case this.localizationService.strings.Admin_Events:
                if (expanded) {
                  this.getInstancesPermission(this.props.permissionsStore.EVENTS, this.props.permissionsStore.eventInstances);
                }
                break;
              case this.localizationService.strings.Admin_MobileApp:
                if (expanded) {
                  this.getInstancesPermission(this.props.permissionsStore.MOBILE_APP, this.props.permissionsStore.mobileAppInstances);
                }
                break;
              case this.localizationService.strings.Admin_Navigator:
                if (expanded) {
                  this.getInstancesPermission(this.props.permissionsStore.NAVIGATOR, this.props.permissionsStore.navigatorInstances);
                }
                break;
              case this.localizationService.strings.Admin_ContentCreator:
                if (expanded) {
                  this.getInstancesPermission(this.props.permissionsStore.CONTENT_CREATOR, this.props.permissionsStore.contentCreatorInstances);
                }
                case this.localizationService.strings.Admin_ContentOrganizer:
                  if (expanded) {
                    this.getInstancesPermission(this.props.permissionsStore.CONTENT_ORGANIZER, this.props.permissionsStore.contentOrganizerInstances);
                  }
                break;
              default:
                break;
            }
          }}
        />
      </div>
    );
  }
}
